/**
 * Shared chart palette for the dashboard module. Every ApexCharts widget
 * imports from here so the whole dashboard speaks the same colour language
 * as the KPI-tile tone map:
 *
 *   primary  – #2563eb (Tailwind blue-600)  → general "brand" series
 *   sky      – #0ea5e9                       → workforce / live indicators
 *   emerald  – #10b981                       → healthy / positive / gained
 *   violet   – #8b5cf6                       → platform / hierarchy
 *   amber    – #f59e0b                       → warnings / soft alerts
 *   rose     – #f43f5e                       → failures / losses
 *   slate    – #64748b                       → neutral / deleted / expired
 *
 * Use `CHART_PALETTE` when a chart needs a full N-swatch series ordering.
 * Use the named exports (SUCCESS_COLOR, FAILURE_COLOR, …) when semantic
 * meaning matters (a "converted" ring is always emerald, "failed" is rose).
 */

export const PRIMARY_COLOR = '#2563eb';
export const SKY_COLOR = '#0ea5e9';
export const EMERALD_COLOR = '#10b981';
export const VIOLET_COLOR = '#8b5cf6';
export const AMBER_COLOR = '#f59e0b';
export const ROSE_COLOR = '#f43f5e';
export const SLATE_COLOR = '#64748b';

// Semantic aliases — use these instead of raw hex whenever the meaning is
// clear ("success" vs "just the emerald slot in a palette").
export const SUCCESS_COLOR = EMERALD_COLOR;
export const WARNING_COLOR = AMBER_COLOR;
export const FAILURE_COLOR = ROSE_COLOR;
export const NEUTRAL_COLOR = SLATE_COLOR;
export const INCOMING_COLOR = SKY_COLOR;
export const OUTGOING_COLOR = AMBER_COLOR;
export const CONNECTED_COLOR = EMERALD_COLOR;
export const DISCONNECTED_COLOR = ROSE_COLOR;

// Default ordered palette for charts that don't need specific semantics —
// primary first because most charts lead with the brand hue, then a
// contrasting sky/emerald/violet/amber/rose cycle that stays legible on
// the silver-blue neu base.
export const CHART_PALETTE = [
  PRIMARY_COLOR,
  SKY_COLOR,
  EMERALD_COLOR,
  VIOLET_COLOR,
  AMBER_COLOR,
  ROSE_COLOR,
  SLATE_COLOR,
];
